exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog .icon .glyphicon {\n  font-size: 3em;\n  color: #fbac42; }\n\n.dialog .content p {\n  padding-bottom: 0.8em; }\n\n.dialog .btn {\n  padding: 10px 20px;\n  display: inline-block; }\n  .dialog .btn.btn-primary, .dialog .btn.btn-primary:hover {\n    background-color: #ef3d36; }\n  .dialog .btn.highlighted {\n    background-color: #61c46e;\n    color: white; }\n    .dialog .btn.highlighted:hover, .dialog .btn.highlighted:focus {\n      background-color: #61c46e;\n      color: white; }\n\n.opaque .modal-backdrop {\n  opacity: 0.95; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/@mprep/shared/lib/angular/components/dialog/dialog.scss
// module id = AAnU
// module chunks = 3